import { createSelector } from '@reduxjs/toolkit';
import { TState } from 'store/types';
import { WebLoginSchema } from '../webLoginSchema';

export const getWebLoginState = (state: TState): WebLoginSchema =>
  state.webLogin;

export const getFormType = createSelector(
  getWebLoginState,
  ({ form }) => form.type,
);
